export default __webpack_public_path__ + "static/media/flask-icon.fefb488d.svg";